import { LoaderContext } from 'context/loaderContext';
import { useContext } from 'react';

export const useLoading = () => useContext(LoaderContext);
